import { render, staticRenderFns } from "./OmniSearchComponent.vue?vue&type=template&id=55cae006"
import script from "./OmniSearchComponent.vue?vue&type=script&lang=js"
export * from "./OmniSearchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports